import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { assetKeys } from "../queryKeys";
import useAPI from "./useAPI";

const useSmartAndRegularAssets = (
  filterEmptyAssets = true,
  filterActiveSmartAsset = true
) => {
  const { fetchAllAssets } = useAPI();

  const {
    data: allAssetsData,
    isLoading: isLoadingAll,
    isSuccess: areAllSuccess,
    isError,
  } = useQuery({
    queryKey: assetKeys.allAssets(),
    queryFn: fetchAllAssets,
    select: (response) => response.data,
  });

  const regularAndActiveSmartAsset = useMemo(() => {
    if (!allAssetsData) return null;

    let regularAssets = allAssetsData.regular || [];
    let smartAssets = allAssetsData.smart || [];

    if (filterEmptyAssets) {
      regularAssets = regularAssets.filter(
        (asset) => asset.entity_ids.length > 0
      );
    }

    if (filterActiveSmartAsset) {
      smartAssets = smartAssets.filter((asset) => asset.is_active);
    }

    return regularAssets.concat(smartAssets);
  }, [allAssetsData, filterEmptyAssets, filterActiveSmartAsset]);

  return {
    isLoadingAll,
    areAllSuccess,
    isError,
    regularAndActiveSmartAsset,
  };
};

export default useSmartAndRegularAssets;
